module.exports = __webpack_public_path__ + "static/media/kamsdetmi.5655f515.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/vychovakzivotu/resources/sponsors/kamsdetmi.jpg
// module id = 417
// module chunks = 0